'use client';

import ImageAsset from '@/components/elements/image-asset';

interface Props {
    ids: string[];
    filenameDisk: string;
    isAnimated?: boolean;
    className?: string;
}

export default function BackgroundGradient(props: Props) {
    return (
        <div className="overflow-hidden">
            <ImageAsset
                priority={false}
                ids={props.ids}
                isAnimated={props.isAnimated}
                assetKey="card"
                quality={10}
                objectFit="contain"
                className="absolute z-0 h-full w-full blur-2xl"
            />
            <div className="absolute h-full w-full bg-black bg-opacity-30" />
        </div>
    );
}
